export default __webpack_public_path__ + "static/media/chat.bb1819d6.png";